import { format, parse, isAfter, isBefore, isEqual } from "date-fns";

export const formatDate = (
  date: Date | string,
  formatString: string = "E, dd MMM yyyy"
) => {
  return format(date instanceof Date ? date : new Date(date), formatString);
};

export const parseDate = (
  date: string,
  formatString: string = "dd-MM-yyyy"
) => {
  return parse(date, formatString, new Date());
};

export const isDateBetween = (
  date: Date,
  dateStart: Date,
  dateEnd: Date,
  inclusive = true
) => {
  return (
    (inclusive && (isEqual(date, dateStart) || isEqual(date, dateEnd))) ||
    (isAfter(date, dateStart) && isBefore(date, dateEnd))
  );
};

export const isDateEqual = (date: Date, dateToCompare: Date) => {
  return isEqual(date, dateToCompare);
};

export const getToday = () => {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  return date;
};

export const getStartOfDay = (date: Date | string = new Date()) => {
  const newDate = date instanceof Date ? date : new Date(date);
  newDate.setHours(0, 0, 0, 0);
  return newDate;
};
